export default "__VITE_ASSET__D4M6yDV9__"